import React, { useContext, useEffect, useState, useRef } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { NavLink, useLocation } from 'react-router-dom';
import { Link } from 'react-scroll';

import LoginComponent from '../login';
import AuthContex from '../../context/autenticacion/authContex';
import * as ROUTES from '../../constans/rutas';

import Logo from '../../asses/img/logo.png';
import Logo2x from '../../asses/img/logo@2x.png';
import Logo3x from '../../asses/img/logo@3x.png';
import LogoB from '../../asses/img/LogoBeparking.png';
import LogoB2x from '../../asses/img/LogoBeparking@2x.png';
import LogoB3x from '../../asses/img/LogoBeparking@3x.png';
import ParkingMedia from '../../asses/img/Logo Parking Media_2.png';

const SHORT_HEADER_PATHS = [
  ROUTES.AYUDAPUNTOS,
  ROUTES.BEAYUDA,
  ROUTES.BECONTRASENAG,
  ROUTES.BETYCGOPASS,
];

const isShortBeParkingHeader = (pathname) =>
  pathname.split('/')[1] === 'beparking' ||
  SHORT_HEADER_PATHS.includes(pathname);

const GuiasDropdown = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const closeAll = () => {
    setOpen(false);
    if (onNavigate) onNavigate();
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  return (
    <div
      className="guias-dropdown"
      ref={ref}
      onMouseEnter={() => {
        if (window.innerWidth >= 992) setOpen(true);
      }}
      onMouseLeave={() => {
        if (window.innerWidth >= 992) setOpen(false);
      }}
    >
      <button
        type="button"
        className="nav-link-custom guias-dropdown-toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        Guias <span className="guias-chevron" aria-hidden="true">▾</span>
      </button>
      {open && (
        <ul className="guias-dropdown-menu">
          <li>
            <NavLink
              to={ROUTES.BEAYUDA}
              onClick={closeAll}
              activeClassName="active"
            >
              Guía Actualización de Datos
            </NavLink>
          </li>
          <li>
            <NavLink
              to={ROUTES.AYUDAPUNTOS}
              onClick={closeAll}
              activeClassName="active"
            >
              Guía Acumulación de Puntos
            </NavLink>
          </li>
        </ul>
      )}
    </div>
  );
};

const CampanasAlianzasDropdown = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const closeAll = () => {
    setOpen(false);
    if (onNavigate) onNavigate();
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  return (
    <div
      className="guias-dropdown campanas-dropdown"
      ref={ref}
      onMouseEnter={() => {
        if (window.innerWidth >= 992) setOpen(true);
      }}
      onMouseLeave={() => {
        if (window.innerWidth >= 992) setOpen(false);
      }}
    >
      <button
        type="button"
        className="nav-link-custom guias-dropdown-toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        Campañas y Alianzas{' '}
        <span className="guias-chevron" aria-hidden="true">
          ▾
        </span>
      </button>
      {open && (
        <ul className="guias-dropdown-menu">
          <li>
            <NavLink
              to={ROUTES.BETYCGOPASS}
              onClick={closeAll}
              activeClassName="active"
            >
              Términos y condiciones GoPass
            </NavLink>
          </li>
        </ul>
      )}
    </div>
  );
};

const HeaderComponent = () => {
  const authContex = useContext(AuthContex);
  const { usuario, usuarioAutenticado, cerrarSesion } = authContex;
  const [show, setShow] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    usuarioAutenticado();
  }, []);

  useEffect(() => {
    setShow(false);
  }, [usuario]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  if (isShortBeParkingHeader(location.pathname)) {
    return (
      <>
        <Navbar
          className="parking-color"
          expand="lg"
          expanded={menuOpen}
          onToggle={setMenuOpen}
        >
          <Container className="container-header-top">
            <NavLink to={ROUTES.BEPARKING} className="navbar-brand">
              <img
                src={LogoB}
                srcSet={`${LogoB2x} 2x, ${LogoB3x} 3x`}
                alt="Logo Parking"
              />
            </NavLink>

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                {location.pathname.split('/').length > 2 ||
                SHORT_HEADER_PATHS.includes(location.pathname) ? (
                  <NavLink
                    activeClassName="drpMenu"
                    to={ROUTES.BEPARKING}
                    onClick={() => setMenuOpen(false)}
                  >
                    Beneficios
                  </NavLink>
                ) : (
                  <Link
                    to="beneficios"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={500}
                    onClick={() => setMenuOpen(false)}
                  >
                    Beneficios
                  </Link>
                )}
                <GuiasDropdown onNavigate={() => setMenuOpen(false)} />
                <CampanasAlianzasDropdown
                  onNavigate={() => setMenuOpen(false)}
                />
                <NavLink
                  activeClassName="nav-borde nombre"
                  to={ROUTES.CONTACTO}
                  onClick={() => setMenuOpen(false)}
                >
                  Contáctanos
                </NavLink>
              </Nav>
              <Nav>
                {usuario ? (
                  <>
                    <NavLink
                      activeClassName="nav-borde w-auto nombre"
                      to={ROUTES.PERFIL}
                      className="nav-borde"
                    >
                      {usuario.nombre}
                    </NavLink>
                    <button
                      className="nav-borde w-auto nombre"
                      onClick={() => cerrarSesion()}
                    >
                      Cerrar sesión
                    </button>
                    <NavLink activeClassName="drpMenu" to={ROUTES.HOME}>
                      Parking Principal
                    </NavLink>
                  </>
                ) : (
                  <>
                    <a
                      href={ROUTES.BEPARKING_LOGIN_URL}
                      className="nav-borde nombre"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Inicia sesión
                    </a>
                    <a
                      href="https://www.beparking.com.co/Register"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-borde w-auto nombre"
                    >
                      Regístrate a be Parking
                    </a>
                    <NavLink activeClassName="drpMenu" to={ROUTES.HOME}>
                      Parking Principal
                    </NavLink>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
            <div className="redes">
              <div
                style={{
                  display: 'flex',
                  alignContent: 'center',
                  alignItems: 'center',
                }}
              >
                <NavLink
                  activeClassName="nav-borde nombre"
                  to={ROUTES.ParkingMedia}
                  className="d-none d-sm-inline-block"
                >
                  <img
                    style={{ width: '80px' }}
                    src={ParkingMedia}
                    alt="Parking Media"
                  />
                </NavLink>
              </div>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>
          </Container>
        </Navbar>
        <LoginComponent open={show} onOpen={(estado) => setShow(estado)} />
      </>
    );
  }

  if (location.pathname.split('/')[1] === 'retentionCertificates') {
    return (
      <>
        <Navbar className="parking-color" expand="lg">
          <Container className="container-header-top">
            <NavLink to={ROUTES.HOME} className="navbar-brand">
              <img
                src={Logo}
                srcSet={`${Logo2x} 2x, ${Logo3x} 3x`}
                alt="Logo Parking"
              />
            </NavLink>

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <NavLink
                  activeClassName="nav-borde nombre"
                  to={ROUTES.CONTACTO}
                >
                  Contáctanos
                </NavLink>
              </Nav>
              <Nav>
                {usuario ? (
                  <NavLink
                    activeClassName="drpMenu"
                    className="nav-borde w-auto nombre"
                    onClick={() => cerrarSesion()}
                    to={ROUTES.HOME}
                  >
                    Cerrar sesión
                  </NavLink>
                ) : (
                  <>
                    <NavLink
                      activeClassName="drpMenu"
                      to={ROUTES.LOGINRETENTION}
                    >
                      Administrador
                    </NavLink>
                    <NavLink activeClassName="drpMenu" to={ROUTES.HOME}>
                      Parking Principal
                    </NavLink>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
            <div className="redes">
              <div
                style={{
                  display: 'flex',
                  alignContent: 'center',
                  alignItems: 'center',
                }}
              >
                <NavLink
                  activeClassName="nav-borde nombre"
                  to={ROUTES.ParkingMedia}
                  className="d-none d-lg-inline-block"
                >
                  <img
                    src={ParkingMedia}
                    alt="Parking Media"
                  />
                </NavLink>
              </div>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
            </div>
          </Container>
        </Navbar>
      </>
    );
  }

  return (
    <Navbar
      className="parking-color"
      expand="lg"
      expanded={menuOpen}
      onToggle={setMenuOpen}
    >
      <Container className="container-header-top">
        <NavLink to={ROUTES.HOME} className="navbar-brand">
          <img
            src={Logo}
            srcSet={`${Logo2x} 2x, ${Logo3x} 3x`}
            alt="Logo Parking"
          />
        </NavLink>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav>
            <NavLink activeClassName="drpMenu" to={ROUTES.NOSOTROS}>
              Nosotros
            </NavLink>
            {location.pathname === '/' ? (
              <Link
                to="parqueaderos"
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
              >
                Parqueaderos
              </Link>
            ) : null}
            {location.pathname !== '/nosotros' ? (
              <NavLink
                to={ROUTES.CONTACTO}
                spy={true}
                smooth={true}
                offset={-100}
                duration={500}
              >
                Contáctanos
              </NavLink>
            ) : (
              <NavLink activeClassName="drpMenu" to={ROUTES.CONTACTO}>
                Contáctanos
              </NavLink>
            )}
            <NavLink
              activeClassName="drpMenu"
              to={ROUTES.NOTICIAS}
              className="nav-borde"
            >
              Noticias
            </NavLink>
            <NavLink
              activeClassName="drpMenu"
              to={ROUTES.EMPRESA}
              className="nav-borde"
            >
              Soy Empresa
            </NavLink>

            <div className="basic-navbar-nav" />

            <NavLink
              activeClassName="drpMenu"
              to={ROUTES.LANDINGFACTURACION}
              className="nav-borde"
            >
              Quiero mi factura electrónica
            </NavLink>
          </Nav>

          <Nav>
            <NavLink to={ROUTES.LANDINGPORTAL} className="nav-borde">
              Servicios
            </NavLink>
            {usuario ? (
              usuario.cms === false ? (
                <NavLink
                  activeClassName="nav-borde nombre"
                  to={ROUTES.BEPARKING}
                  className="nav-borde"
                >
                  be parking
                </NavLink>
              ) : (
                <>
                  <NavLink
                    activeClassName="nav-borde nombre"
                    to={ROUTES.BEPARKING}
                    className="nav-borde"
                  >
                    be parking
                  </NavLink>
                  <NavLink
                    activeClassName="nav-borde nombre"
                    to={ROUTES.PERFIL}
                    className="nav-borde"
                  >
                    {usuario.nombre}
                  </NavLink>
                </>
              )
            ) : (
              <NavLink
                activeClassName="drpMenu"
                className="nav-borde nombre"
                to={ROUTES.BEPARKING}
              >
                be parking
              </NavLink>
            )}
          </Nav>

          <Nav>
            <a
              href="https://parkingcorp.parking.net.co/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                backgroundColor: '#0B5E68',
                color: '#FFFFFF',
                fontWeight: 'bold',
                borderRadius: '30px',
                padding: '3px 10px',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                fontSize: '12px',
                display: 'inline-block',
                lineHeight: '1.5',
              }}
            >
              Productos corporativos
            </a>
            <NavLink
              to={ROUTES.ParkingMedia}
              className="d-none d-lg-inline-flex align-items-center"
              style={{ marginLeft: '6px' }}
            >
              <img src={ParkingMedia} alt="Parking Media" style={{ width: '68px', height: 'auto' }} />
            </NavLink>
            <NavLink
              to={ROUTES.ParkingMedia}
              className="d-lg-none"
              onClick={() => setMenuOpen(false)}
            >
              Parking Media
            </NavLink>
          </Nav>
        </Navbar.Collapse>
        <div className="redes" style={{ display: 'flex' }}>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
        </div>
      </Container>
    </Navbar>
  );
};

export default HeaderComponent;
